import type { FUSportsCountry } from "fansunited-data-layer";

/**
 * Resolve country flag URL from FUSportsCountry data.
 * Falls back to flagcdn.com if no flag URL is provided by the API.
 */
export function getCountryFlagUrl(country?: FUSportsCountry): string | undefined {
    if (!country) return undefined;
    return country.flag || (country.code ? `https://flagcdn.com/w40/${country.code.toLowerCase()}.png` : undefined);
}
